import React, { useState, useEffect } from "react";
import {
  IonContent,
  IonPage,
  IonTitle,
  IonToolbar,
  IonHeader,
  IonButtons,
  IonList,
  IonItemGroup,
  IonItemDivider,
  IonLabel,
  IonBackButton,
  IonButton,
  IonLoading,
} from "@ionic/react";
import VisitItem from "./VisitItem";
import { useDispatch, useSelector } from "react-redux";
import { approveHouseVisits } from "./controllerVisitsSlice";
import { listControllersHouseVisits } from "../../api/server";
import { useQuery } from "react-query";
import moment from "moment";
import Logo from "../../components/Logo";
import Empty from "../../components/Empty";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
const groupBy = require("lodash/groupBy");

const ControllerVisits = (props) => {
  const [tableItems, setTableitems] = useState([]);
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const activeEmployee = useSelector((state) => state.employee.activeEmployee);
  const { scopePrefix } = useSelector((state) => state.auth);
  const { activeMonth } = useSelector((state) => state.visits);

  const { page: controllerVisitsPage } = useSelector(
    (state) => state.controllerVisits
  );

  let from = moment(activeMonth).startOf("month").format();
  let to = moment(activeMonth).endOf("month").format();

  const loading = useSelector(
    (state) => state.pendingActions["controllersHouseVisits/approve"]
  );

  const newState = {
    ...controllerVisitsPage,
    query: {
      from,
      to,
    },
  };
  const employeeId = activeEmployee.id;

  const { isFetching, data, status, error } = useQuery(
    [
      controllerVisitsPage,
      activeMonth,
      scopePrefix,
      employeeId,
      history.location,
    ],
    async () => {
      const result = await listControllersHouseVisits({
        ...newState,
        scopePrefix,
        employeeId,
      });
      return result.data.items;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled:
        activeEmployee.id !== null &&
        activeEmployee.id !== undefined &&
        history.location.pathname === "/app/controllerVisits",
    }
  );

  useEffect(() => {
    const grouped = groupBy(data, (dt) =>
      moment(dt.date).startOf("day").format()
    );
    setTableitems(grouped);
  }, [data]);

  const onApprove = async () => {
    const action = await dispatch(approveHouseVisits({ data }));
    if (!action.error) {
      history.goBack();
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: "app.mobile.controller_visits",
            })}
          </IonTitle>
          <IonButtons slot="end">
            <Logo />
          </IonButtons>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/app/home"
              text={intl.formatMessage({
                id: "app.mobile.home",
              })}
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      {isFetching ? (
        <IonContent />
      ) : (
        <IonContent>
          {Object.keys(tableItems).length > 0 ? (
            <>
              <IonList>
                {Object.keys(tableItems).map((key) => {
                  return (
                    <IonItemGroup key={key}>
                      <IonItemDivider>
                        <IonLabel>{moment(key).format("DD/MM/YYYY")}</IonLabel>
                      </IonItemDivider>
                      {tableItems[key].map((item) => (
                        <VisitItem key={item.id} item={item} />
                      ))}
                    </IonItemGroup>
                  );
                })}
              </IonList>
              <IonButton
                style={{ margin: "8px 16px", borderRadius: "10px" }}
                color="primary"
                expand="full"
                onClick={onApprove}
              >
                {intl.formatMessage({
                  id: "app.mobile.actions.approve_all",
                })}
              </IonButton>
            </>
          ) : (
            <Empty
              title={intl.formatMessage({
                id: "app.mobile.no_result_title",
              })}
              subTitle={intl.formatMessage({
                id: "app.mobile.no_result_sub_title",
              })}
              loading={loading}
            />
          )}
        </IonContent>
      )}

      {isFetching && <IonLoading isOpen={true} />}
    </IonPage>
  );
};

export default ControllerVisits;
